export default [
  {
    name: 'process',
    title: 'Pendiente',
    description: 'La orden se encuentra en proceso y NO se ha realizado el pago.',
    color: 'secondary',
    meta: {
      hidden: true
    }
  },
  {
    name: 'in_process',
    title: 'En proceso',
    description: 'La orden se encuentra en proceso y NO se ha realizado el pago.',
    color: 'secondary',
    meta: {
      hidden: true
    }
  },
  {
    name: 'paid',
    title: 'Pagada',
    description: '¡La orden está pagada! Ponte en contacto con tu cliente lo antes posible.',
    color: 'success',
    meta: {
      isActive: true,
      hidden: true
    }
  },
  {
    name: 'canceled',
    title: 'Cancelada',
    description: 'La orden ha sido cancelada o el usuario inició una orden nueva.',
    color: 'danger',
    meta: {
      hidden: true
    }
  },
  {
    name: 'refunded',
    title: 'Reembolso',
    description: 'La orden ha sido cancelada en el mismo día en que se creó.',
    color: 'danger',
    meta: {
      hidden: true
    }
  },
  {
    name: 'preparing',
    title: 'En preparación',
    description: 'Estás preparando los productos de esta orden para su envío.',
    color: 'warning',
    meta: {
      isActive: true,
    }
  },
  {
    name: 'sent',
    title: 'Enviada',
    description: 'La orden ha sido enviada al cliente.',
    color: 'warning',
    meta: {
      isActive: true,
    }
  },
  {
    name: 'delivered',
    title: 'Terminada',
    description: 'La orden ha sido completada.',
    color: 'info',
    meta: {
      isActive: true,
    }
  },
  {
    name: 'pay_on_delivery',
    title: 'Pago contra entrega',
    title_short: 'PCE',
    description: 'Se realizará el pago de la orden en la entrega.',
    color: 'primary',
    meta: {
      isActive: true,
      hidden: true
    }
  }
]
